import classes from './Filtersection.module.scss';
import { Button } from 'primereact/button';
import { useFilterSection } from './useFilterSection.logic';
import { Dropdown } from 'primereact/dropdown';
import { AutoComplete } from 'primereact/autocomplete';
import { msPlanBulkEditFilterInterface } from 'Interfaces/FDPInterfaces/tmsInterfaces';
import AsyncSelect from 'react-select/async';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import { X } from 'lucide-react';

const FilterSection = ({
  isDataLoading,
  handleApplyFilter,
  parentFilterPayload,
  daveToSaveIsThere,
}: {
  isDataLoading: boolean;
  handleApplyFilter: (filterData: msPlanBulkEditFilterInterface) => void;
  parentFilterPayload: msPlanBulkEditFilterInterface;
  daveToSaveIsThere: boolean;
}) => {
  const {
    staticDropDownOptions,
    isAllMoleculesLoading,
    filterData,
    filteredMolecules,
    isAllConceptLoading,
    filteredConcept,
    setFilterValues,
    handleFilter,
    handlerFunctions,
    isFilterButtonDisabled,
    getfilterOption,
    isFilterApplyButtonConfirmationVisible,
    setIsFilterApplyButtonConfirmationVisible,
    handleClickClearFilters,
  } = useFilterSection({
    isDataLoading,
    handleApplyFilter,
    parentFilterPayload,
    daveToSaveIsThere,
  });

  return (
    <div className={classes.container}>
      <div className={classes.inputSection}>
        <div className={classes.labelSection}>
          <div>
            <label
              htmlFor="ramping"
              className={classes.inputLabel}
              style={{ paddingRight: '6rem' }}
            >
              Ramping:
            </label>
          </div>
          <div>
            <label
              htmlFor="molecule"
              className={classes.inputLabel}
              style={{ paddingRight: '5.9rem' }}
            >
              Molecule:
            </label>
          </div>
          <div>
            <label
              htmlFor="sellingCategory"
              className={classes.inputLabel}
              style={{ paddingRight: '3rem' }}
            >
              Selling category:
            </label>
          </div>
        </div>
        <div className={classes.inpSection}>
          <div>
            <Dropdown
              className={classes.dropDownBox}
              value={filterData.Ramping}
              options={staticDropDownOptions.RampingOptions}
              placeholder="Yes/No..."
              optionLabel="label"
              optionValue="value"
              showClear
              onChange={e => setFilterValues('Ramping', e.target.value ?? '')}
            />
          </div>
          <div className={classes.clearableWrapper}>
            {/* molecule auto complete */}
            <AutoComplete
              onSelect={e => setFilterValues('MoleculeAndDosageForm', e.value)}
              autoHighlight={true}
              delay={100}
              loadingIcon={null}
              onDropdownClick={() => console.log('clicked')}
              disabled={isAllMoleculesLoading}
              placeholder="Search a Molecule...."
              style={{ flexGrow: 1 }}
              className={classes.inputBox}
              value={filterData.MoleculeAndDosageForm}
              suggestions={filteredMolecules}
              dropdownIcon={null}
              completeMethod={e => handlerFunctions.handleFilterMolecules(e.query)}
              onChange={e => setFilterValues('MoleculeAndDosageForm', e.value)}
            />
            {filterData.MoleculeAndDosageForm && (
              <button
                type="button"
                className={classes.autoCompleteClearBtn}
                onClick={() => setFilterValues('MoleculeAndDosageForm', '')}
              >
                <X size={12} />
              </button>
            )}
          </div>
          <div>
            <Dropdown
              className={classes.dropDownBox}
              value={filterData.SellingCategory}
              options={staticDropDownOptions.SellingCategoryOptions}
              placeholder="Select Selling Category..."
              optionLabel="label"
              optionValue="value"
              showClear
              onChange={e => setFilterValues('SellingCategory', e.target.value ?? '')}
            />
          </div>
        </div>
        <div className={classes.labelSection}>
          <div>
            <label
              htmlFor="concept"
              className={classes.inputLabel}
              style={{ paddingRight: '5.9rem' }}
            >
              Concept:
            </label>
          </div>
          <div>
            <label
              htmlFor="stratCode"
              className={classes.inputLabel}
              style={{ paddingRight: '2.4rem' }}
            >
              Strategy Code:
            </label>
          </div>
          <div>
            <label
              htmlFor="GFC"
              className={classes.inputLabel}
              style={{ paddingRight: '7.5rem', marginTop: '0.5rem' }}
            >
              GFC:
            </label>
          </div>
        </div>
        <div className={classes.inpSection}>
          <div className={classes.clearableWrapper}>
            {/* concept auto complete */}
            <AutoComplete
              onSelect={e => setFilterValues('Concept', e.value)}
              autoHighlight={true}
              delay={200}
              loadingIcon={null}
              disabled={isAllConceptLoading}
              placeholder="Search a Concept...."
              style={{ flexGrow: 1, width: '100%', height: '2rem' }}
              className={classes.inputBox}
              value={filterData.Concept}
              suggestions={filteredConcept}
              dropdownIcon={null}
              completeMethod={e => handlerFunctions.handleFilterConcepts(e.query)}
              onChange={e => setFilterValues('Concept', e.value)}
            />
            {filterData.Concept && (
              <button
                type="button"
                className={classes.autoCompleteClearBtn}
                onClick={() => setFilterValues('Concept', '')}
              >
                <X size={12} />
              </button>
            )}
          </div>
          <div>
            <Dropdown
              className={classes.dropDownBox}
              value={filterData.StrategyCode}
              options={staticDropDownOptions.StratCodeOptions}
              optionLabel="label"
              placeholder="Select Strategy Code.."
              optionValue="value"
              showClear
              onChange={e => setFilterValues('StrategyCode', e.target.value ?? '')}
            />
          </div>
          <div>
            <AsyncSelect
              loadOptions={getfilterOption.fetchGFCSuggestions}
              onChange={option => {
                setFilterValues('GFC', option?.value || '');
              }}
              defaultOptions
              isClearable
              placeholder="Search a GFC..."
              value={filterData.GFC ? { label: filterData.GFC, value: filterData.GFC } : null}
              styles={{
                // Fixes the overlapping problem of the component
                menu: provided => ({ ...provided, zIndex: 20 }),
              }}
            />
          </div>
        </div>
      </div>
      <div className={classes.btnComponent}>
        {/* Filter button section */}
        <div className={classes.buttonWrappperDiv}>
          <Button className={classes.clearFilterButton} onClick={handleClickClearFilters}>
            Clear Filters
          </Button>
          <Button
            className={classes.applyFilterButton}
            onClick={handleFilter}
            disabled={isFilterButtonDisabled()}
          >
            Apply
          </Button>
        </div>
      </div>
      {isFilterApplyButtonConfirmationVisible && (
        <ConfirmationModal
          visibility={isFilterApplyButtonConfirmationVisible}
          modalHeading="Confirmation"
          modalContent={`Changes are not saved, Are you sure you want to apply filter ?`}
          loading={false}
          confirmLabel="Confirm"
          handleCancel={() => setIsFilterApplyButtonConfirmationVisible(false)}
          handleConfirm={() => {
            handleApplyFilter(filterData);
            setIsFilterApplyButtonConfirmationVisible(false);
          }}
        />
      )}
    </div>
  );
};

export default FilterSection;
